import { ArrowDown } from "lucide-react";

const HERO_IMG = "/assets/hilltop-tap-room.webp";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden bb-grain"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-[#09090B]" />
      <div className="absolute inset-0 bg-black/30" />

      <div className="bb-container relative z-10 px-6 md:px-12 py-32 w-full">
        <div className="max-w-3xl bb-fade-up">
          <span className="bb-eyebrow">Hilltop Brewery — Bassano Romano</span>
          <h1
            className="bb-display text-7xl sm:text-8xl lg:text-[10rem] leading-[0.9] mt-6"
            style={{ color: "var(--bb-text)" }}
            data-testid="hero-title"
          >
            BEER
            <br />
            <span style={{ color: "var(--bb-primary)" }}>BATTLE</span>
          </h1>
          
          <p className="mt-8 text-lg md:text-xl text-zinc-300 max-w-xl leading-relaxed">
            Il concorso BJCP a stile libero che mette alla prova il talento dei migliori homebrewers.
            Feedback professionali, analisi certificate e la scalata verso il titolo <span style={{ color: "var(--bb-primary)" }} className="font-bold">Best of Show</span>.
            <br />
            <p className="mt-4">
            </p>
            Qui, la libertà stilistica incontra il giudizio dei grandi esperti.
          </p>

          <div className="mt-12 flex flex-wrap gap-4 items-center">
            <a href="#iscrizione" data-testid="hero-cta-register" className="bb-btn-primary">
              Iscrivi la tua birra
            </a>
            <a href="#evento" data-testid="hero-cta-discover" className="bb-btn-outline">
              Scopri l'evento
            </a>
            {/* NUOVO PULSANTE MENZIONI SPECIALI */}
            <a href="#special-mentions" className="bb-btn-outline">
              Menzioni Speciali
            </a>
          </div>
        </div>
      </div>

      <a
        href="#evento"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-zinc-400 hover:text-[var(--bb-primary)] transition-colors animate-bounce"
        aria-label="Scroll"
      >
        <ArrowDown size={28} />
      </a>
    </section>
  );
}